var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2a6ed772\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./bodyMass.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppSvgIcon/iconsTemplate/contents/bodyMass.vue
// module id = f4fa4bca958e5e8c1ed3
// module chunks = 89